'use client';

import { observer } from 'mobx-react-lite';
import useSearchProducers from 'hooks/useSearchProducers';
import SearchContent from 'components/Shared/SearchContent/SearchContent';
import SearchProducersList from 'components/SearchProducersList/SearchProducersList';
import { ParamsResult } from 'ParamsResult.d';
import { SearchProducersResult } from 'searchProducers.d';
import { urlParamsSearch } from 'constants/search';
import { updateUrlQueryParam } from 'utils/misc';

export type SearchProducersTemplateProps = {
  params: ParamsResult;
  searchDataResult: SearchProducersResult;
  isMobile: boolean;
};

function SearchProducersTemplate({ searchDataResult, params, isMobile }: SearchProducersTemplateProps) {
  const searchProducersStore = useSearchProducers();
  searchProducersStore.hydrate(searchDataResult);

  return (
    <SearchContent
      pageTypeText="produtores"
      searchResult={searchProducersStore?.searchDataResult}
      totalPages={searchProducersStore?.totalPages}
      isFetching={searchProducersStore?.isFetching}
      isMobile={isMobile}
      onChangePage={(page: string | number) => {
        if (!isMobile) {
          updateUrlQueryParam({ param: urlParamsSearch.page, value: String(page) });
        }
        searchProducersStore.fetchPaginationData({
          query: window?.location?.search,
          isMobile,
          page,
          onSuccess: () => window?.scrollTo({ top: 0, left: 0 }),
        });
        return +page;
      }}
    >
      <SearchProducersList producers={searchProducersStore?.searchDataResult?.data} serviceParams={params} />
    </SearchContent>
  );
}

export default observer(SearchProducersTemplate);
